import { LucideProps } from 'lucide-react'

const Faculty = (props: LucideProps) => (
  <svg
    width="300"
    height="274"
    viewBox="0 0 300 274"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="300" height="274" fill="#E6F3F4" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M150 146C177.614 146 200 123.614 200 96C200 68.3858 177.614 46 150 46C122.386 46 100 68.3858 100 96C100 123.614 122.386 146 150 146ZM200 214C200 214.334 199.997 214.667 199.99 215H200V274H100V215H100.01C100.003 214.667 100 214.334 100 214C100 186.386 122.386 164 150 164C177.614 164 200 186.386 200 214Z"
      fill="#CEDAE3"
    />
  </svg>
)

export default Faculty
